$(function () {
  gsap.registerPlugin(ScrollTrigger);

  const fadein_items = [
    ".main-wrap article",
    ".all-button-wrap",
    ".custom-image-text-row",
    ".athlete-introduction-banner",
    ".bobson-license-logos-box",
    ".overseas-licensee-box",
    ".pagenation-wrapper",
    ".history_all-btn_wrapper",
    ".athlete-container"
  ];

  // need delay
  const delay_items = [
    ".main-wrap article",
    ".bobson-trademark-logos__grid .bobson-trademark-logos__item",
    ".special-grid-images__grid .special-grid-images__item",
  ];

  fadein_items.forEach(selector => {
    $(selector).each(function (index, element) {
      // before
      gsap.set(element, { opacity: 0, y: 40 });

      // delay
      const applyDelay = delay_items.some(sel => $(element).is(sel));

      let delay = 0;
      let startPos = "top 85%";

      if ($(element).is('.main-wrap article')) {
        if (window.innerWidth < 767) {
          delay = applyDelay ? index * 0 : 0;
          startPos = "top 80%";
        } else {
          let itemsPerRow = 1;
          if (window.innerWidth >= 989) {
            itemsPerRow = 3;
          } else if (window.innerWidth >= 767) {
            itemsPerRow = 2;
          }
          const rowIndex = Math.floor(index / itemsPerRow);
          const colIndex = index % itemsPerRow;
          delay = applyDelay ? (rowIndex * 0.1) + (colIndex * 0.1) : 0;
          startPos = "top 90%";
        }
      } else {
        delay = applyDelay ? index * 0.15 : 0;
      }

      gsap.to(element, {
        scrollTrigger: {
          trigger: element,
          start: startPos,
          toggleActions: "play none none none"
        },
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power2.out",
        delay: delay
      });
    });
  });

  // reverse fadeIn ** only PC **
  function reverseFadeIn(selector, delayStep = 0.3) {
    const items = document.querySelectorAll(selector);
    const reversedItems = Array.from(items).reverse();
  
    reversedItems.forEach((item, index) => {
      gsap.fromTo(
        item,
        { opacity: 0 },
        {
          opacity: 1,
          duration: 0.2,
          delay: index * delayStep,
          scrollTrigger: {
            trigger: item,
            start: "top 85%",
            toggleActions: "play none none none",
          }
        }
      );
    });
  }
  // reverse target
  if (window.matchMedia("(min-width: 601px)").matches) {
    reverseFadeIn(".timeline-img");
    reverseFadeIn(".timeline-text__item");
    // reverseFadeIn(".feature-box", 0.2); // ex.) delay unique
  }

});
